import React, { useEffect, useState } from 'react';
import client, { urlFor } from '../../config/sanityClient';

function Clients() {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const query = `*[_type == "clients" && isActive == true] | order(order asc, name asc) {
          _id,
          name,
          logo,
          projectLink,
          "logoUrl": logo.asset->url
        }`;
        const result = await client.fetch(query);
        setClients(result || []);
      } catch (error) {
        console.error('Error fetching clients:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchClients();
  }, []);

  if (loading || !clients.length) return null;

  // Duplicar para el efecto infinito
  const track = [...clients, ...clients];

  return (
    <section className="py-10 bg-white dark:bg-[#0d0d0d] overflow-hidden">
      <style>{`
        @keyframes marquee {
          from { transform: translateX(0); }
          to   { transform: translateX(-50%); }
        }
        .marquee-track {
          animation: marquee 28s linear infinite;
          will-change: transform;
        }
        .marquee-track:hover {
          animation-play-state: paused;
        }
      `}</style>

      <div className="max-w-6xl mx-auto px-4 text-center mb-8">
        <p className="inline-block text-[10px] font-medium uppercase tracking-[0.2em] text-[#11b36d] bg-[#11b36d]/10 border border-[#11b36d]/20 rounded-full px-3 py-1 mb-5">Clientes</p>
        <h2 className="text-3xl font-thin tracking-tighter sm:text-4xl text-[#0b2b40] dark:text-white">
          Que <span className="text-gradient text-short">confían</span> en nosotros
        </h2>
      </div>

      <div className="relative max-w-6xl mx-auto px-4 overflow-hidden">
        {/* Fade izquierda */}
        <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-white dark:from-[#0d0d0d] to-transparent z-10 pointer-events-none" />
        {/* Fade derecha */}
        <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-white dark:from-[#0d0d0d] to-transparent z-10 pointer-events-none" />

        <div className="flex marquee-track">
          {track.map((c, i) => {
            const imgSrc = urlFor(c.logo).url() || c.logoUrl;
            const alt = c.logo?.alt || `Logo de ${c.name}`;

            const logo = (
              <img
                src={imgSrc}
                alt={alt}
                loading="lazy"
                draggable={false}
                className="h-16 w-auto max-w-[120px] object-contain grayscale dark:invert opacity-40 hover:opacity-80 transition-opacity duration-300 remove-grayscale"
              />
            );

            return (
              <div
                key={`${c._id}-${i}`}
                className="flex items-center justify-center px-10 shrink-0"
              >
                {c.projectLink ? (
                  <a
                    href={c.projectLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={c.name}
                  >
                    {logo}
                  </a>
                ) : logo}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default Clients;
